module.exports = __webpack_public_path__ + "img/user_icon_white.3cbc255f.svg";